import { useTranslation } from 'react-i18next';
import * as Styled from './ClassyFooter.styled';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const CURRENT_YEAR = new Date().getFullYear();

/**
 * Omitted ClassyFooterBlockDataProps and ClassyFooterExternalDataProps because ClassyFooter
 * is not configurable in the builder.
 */

const PolicyLink = ({
  href,
  children
}) => /*#__PURE__*/_jsx("a", {
  href: href,
  target: "_blank",
  rel: "noopener noreferrer",
  children: children
});
/**
 * The `ClassyFooter` content block renders copyright, privacy policy, terms and log-in links.
 */
export const ClassyFooter = ({
  privacyLinkUrl = '',
  termsLinkUrl = '',
  isLoggedIn = false,
  onLogin,
  ...rest
}) => {
  const {
    t
  } = useTranslation('blocks.classyFooter');
  return /*#__PURE__*/_jsxs(Styled.FooterContainer, {
    ...rest,
    children: [/*#__PURE__*/_jsxs(Styled.LeftContainer, {
      children: [t('ClassyFooter.copyrightText', {
        currentYear: CURRENT_YEAR,
        defaultValue: 'Copyright © {{currentYear}}'
      }), ` • ${t('ClassyFooter.allRightsReserved', 'All rights reserved')} • `, /*#__PURE__*/_jsx(PolicyLink, {
        href: privacyLinkUrl,
        children: t('ClassyFooter.classyPrivacyPolicyLink', 'Privacy Notice')
      }), ' • ', /*#__PURE__*/_jsx(PolicyLink, {
        href: termsLinkUrl,
        children: t('ClassyFooter.termsOfServiceLink', 'Terms of Service')
      })]
    }), /*#__PURE__*/_jsx(Styled.RightContainer, {
      children: !isLoggedIn && onLogin ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [t('ClassyFooter.signInLabel', 'Have an account?'), /*#__PURE__*/_jsx(Styled.SignInButton, {
          onClick: onLogin,
          children: t('ClassyFooter.signInButton', 'Sign in')
        }), ' ']
      }) : ''
    })]
  });
};